export const imageSourceToCanvas = (source: TexImageSource): HTMLCanvasElement => {
  const { width = 0, height = 0 } = source || {};

  const canvas = document.createElement("canvas");
  canvas.width = Math.max(width, 0);
  canvas.height = Math.max(height, 0);

  const context = canvas.getContext("2d");

  if (!context || !canvas.width || !canvas.height) return canvas;

  if (source instanceof ImageData) {
    context.putImageData(source, 0, 0);
  } else {
    context.drawImage(source, 0, 0, width, height);
  }

  return canvas;
};
